(() => {
  const init = scope => scope.querySelectorAll('[data-ss-pack-builder]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const text = JSON.parse(root.querySelector('[data-pack-text]').textContent);
    const current = JSON.parse(root.querySelector('[data-pack-product]').textContent);
    const cache = new Map();
    const base = root.dataset.root.replace(/\/$/, '') + '/';
    const details = root.querySelector('.ss-pack-details');
    const rows = root.querySelector('[data-pack-rows]');
    const total = root.querySelector('[data-pack-total]');
    const status = root.querySelector('[data-pack-status]');
    const add = root.querySelector('[data-pack-add]');
    const native = root.parentElement.querySelector('.product__atc');
    let catalogPromise, count = 1, generation = 0, busy = false;
    const selections = [];
    const eligible = v => v.available && !(v.compare_at_price && v.compare_at_price > v.price);
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: root.dataset.currency || 'USD' }).format(cents / 100);
    const getProduct = handle => {
      if (!cache.has(handle)) cache.set(handle, fetch(base + 'products/' + encodeURIComponent(handle) + '.js').then(r => { if (!r.ok) throw Error(); return r.json(); }).catch(e => { cache.delete(handle); throw e; }));
      return cache.get(handle);
    };
    const catalog = () => catalogPromise ||= fetch(root.dataset.catalog).then(r => { if (!r.ok) throw Error(); return r.json(); }).then(data => root.dataset.audience === 'kids' ? [...data.kids, ...data.adult] : data.adult);
    const option = (value, label, disabled = false) => {
      const node = document.createElement('option'); node.value = value; node.textContent = label; node.disabled = disabled; return node;
    };
    const refresh = () => {
      const valid = selections.length >= count && selections.slice(0, count).every(s => s?.variant && eligible(s.variant));
      add.disabled = busy || !valid;
      total.textContent = valid ? money(selections.slice(0, count).reduce((sum, s) => sum + s.variant.price, 0)) : '—';
    };
    const render = async () => {
      const version = ++generation;
      rows.replaceChildren(); status.textContent = text.loading; add.disabled = true;
      try {
        const choices = await catalog();
        if (version !== generation || count === 1) return;
        const allChoices = [{...choices.find(p => p.handle === current.handle),handle:current.handle,title:current.title,image:current.featured_image || current.images?.[0]}, ...choices.filter(p => p.handle !== current.handle)];
        for (let i = 0; i < count; i++) {
          const field = document.createElement('fieldset'); field.className = 'ss-pack-row';
          const legend = document.createElement('legend'); legend.textContent = text.pack + ' ' + (i + 1); field.append(legend);
          const styleLabel = document.createElement('div'); styleLabel.className = 'ss-style-field'; styleLabel.textContent = text.style;
          const style = document.createElement('select'); style.setAttribute('aria-label', text.pack + ' ' + (i + 1) + ' ' + text.style);
          allChoices.forEach(p => style.append(option(p.handle, p.title.replace(/Squid Socks®/g, '').trim())));
          style.hidden = true;
          const picker = document.createElement('details'); picker.className = 'ss-style-picker';
          const summary = document.createElement('summary'); summary.setAttribute('aria-label', text.pack + ' ' + (i + 1) + ' ' + text.style);
          const preview = document.createElement('img'); preview.width = 64; preview.height = 64; preview.alt = '';
          const selectedName = document.createElement('span');
          const chevron = document.createElement('span'); chevron.className = 'ss-style-chevron'; chevron.textContent = '⌄'; chevron.setAttribute('aria-hidden', 'true');
          summary.append(preview, selectedName, chevron);
          const grid = document.createElement('div'); grid.className = 'ss-style-grid';
          const imageUrl = value => { const url = new URL(typeof value === 'string' ? value : value?.src || '', location.origin); url.searchParams.set('width', '240'); return url.href; };
          const displayName = title => title.replace(/Baby & Kids (?:Cotton )?(?:Ankle |Crew )?Grip Socks, /, '').replace(/Kids Grip Socks, /, '').replace(/Adult (Ankle|Crew|No-Show) Grip Socks, (.*), 3-Pack/, '$2 · $1').replace(/, 3-Pack$/, '');
          const audienceDescription = product => /^Adult /.test(product.title) ? 'Adults' : product.fabricLabel || allChoices.find(p => p.handle === product.handle)?.fabricLabel || 'Kids';
          const updatePreview = product => {
            selectedName.textContent = audienceDescription(product) + ' · ' + displayName(product.title);
            const source = product.featured_image || product.image || product.images?.[0];
            if (source) { preview.src = imageUrl(source); preview.hidden = false; } else preview.hidden = true;
            grid.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.handle === style.value)));
          };
          ['kids', 'adult'].forEach(audience => {
            const audienceChoices = allChoices.filter(product => (/^Adult /.test(product.title) ? 'adult' : 'kids') === audience);
            if (!audienceChoices.length) return;
            const heading = document.createElement('div'); heading.className = 'ss-style-category';
            heading.textContent = audience === 'adult' ? 'Adults' : 'Kids'; grid.append(heading);
            audienceChoices.forEach(product => {
            const button = document.createElement('button'); button.type = 'button'; button.dataset.handle = product.handle;
            button.setAttribute('aria-label', product.title); button.setAttribute('aria-pressed', 'false');
            const photo = document.createElement('img'); photo.width = 120; photo.height = 120; photo.alt = ''; photo.loading = 'lazy'; photo.decoding = 'async';
            if (product.image) photo.src = imageUrl(product.image);
            const name = document.createElement('span'); name.textContent = displayName(product.title);
            const audienceLabel = document.createElement('small'); audienceLabel.textContent = audienceDescription(product); name.append(audienceLabel);
            button.append(photo, name); button.addEventListener('click', () => {
              if (busy) return;
              style.value = product.handle; updatePreview(product); picker.open = false;
              style.dispatchEvent(new Event('change', {bubbles: true})); summary.focus();
            }); grid.append(button);
            });
          });
          picker.append(summary, grid); picker.addEventListener('keydown', event => { if (event.key === 'Escape') { picker.open = false; summary.focus(); } });
          styleLabel.append(style, picker); field.append(styleLabel);
          const sizeLabel = document.createElement('label'); sizeLabel.textContent = text.size;
          const size = document.createElement('select'); size.setAttribute('aria-label', text.pack + ' ' + (i + 1) + ' ' + text.size);
          sizeLabel.append(size); field.append(sizeLabel); rows.append(field);
          if (!selections[i]) selections[i] = {handle:current.handle, variant:null, desired:i === 0 ? root.closest('form')?.querySelector('[name="id"]')?.value || root.dataset.variant : null};
          style.value = selections[i].handle; updatePreview(allChoices.find(p => p.handle === style.value) || current);
          let request = 0;
          const load = async () => {
            const token = ++request;
            const previous = selections[i];
            const desired = previous.handle === style.value ? previous.variant?.id || previous.desired : null;
            selections[i] = {handle:style.value, variant:null};
            size.replaceChildren(option('',text.loading)); size.disabled = true; refresh();
            try {
              const product = await getProduct(style.value);
              if (token !== request || version !== generation) return;
              updatePreview(product);
              if ((product.tags || []).includes('clearance')) throw Error(text.notEligible);
              size.replaceChildren(option('',text.chooseSize));
              product.variants.forEach(v => size.append(option(String(v.id), v.title + ' · ' + money(v.price) + (eligible(v) ? '' : ' · ' + (v.available ? text.notEligible : text.unavailable)), !eligible(v))));
              const selected = product.variants.find(v => String(v.id) === String(desired) && eligible(v));
              if (selected) { size.value = String(selected.id); selections[i].variant = selected; }
              size.disabled = !product.variants.some(v => eligible(v));
              size.onchange = () => { selections[i].variant = product.variants.find(v => String(v.id) === size.value && eligible(v)) || null; status.textContent = ''; refresh(); };
              status.textContent = ''; refresh();
            } catch {
              if (token !== request || version !== generation) return;
              size.replaceChildren(option('',text.error)); status.textContent = text.error; refresh();
            }
          };
          style.onchange = load;
          await load();
          if (version !== generation) return;
        }
      } catch { if (version === generation) status.textContent = text.error; }
      refresh();
    };
    root.querySelectorAll('[data-count]').forEach(button => button.addEventListener('click', () => {
      if (busy) return;
      count = Number(button.dataset.count); root.dataset.count = String(count);
      if (native) native.dataset.packHidden = String(count > 1);
      document.body.dataset.ssMultiPack = String(count > 1);
      root.querySelectorAll('[data-count]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      details.hidden = count === 1;
      if (count === 1) { generation++; return; }
      render();
    }));
    add.addEventListener('click', async () => {
      if (busy || add.disabled) return;
      if (!selections.slice(0,count).every(s => s?.variant && eligible(s.variant))) { status.textContent = text.chooseAll; return; }
      busy = true; refresh(); add.textContent = text.adding; status.textContent = '';
      const merged = new Map();
      selections.slice(0,count).forEach(s => merged.set(s.variant.id,(merged.get(s.variant.id) || 0) + 1));
      try {
        const response = await fetch(base + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:[...merged].map(([id,quantity]) => ({id,quantity}))})});
        const data = await response.json();
        if (!response.ok) throw Error(data.description || text.cartError);
        window.location.assign(root.dataset.cart);
      } catch(e) {
        status.textContent = e.message || text.cartError;
        const review = document.createElement('a'); review.href = root.dataset.cart; review.textContent = text.reviewCart; review.style.textDecoration = 'underline'; status.append(document.createTextNode(' '), review);
        busy = false; add.textContent = text.add; refresh();
      }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

